import React from 'react';

import TronLinkLogo from './TronlinkPro.jpg';

const WEBSTORE_URL = 'https://www.tronlink.org/';

const logo = (
    <div className='col-sm-4 text-center'>
        <img src={ TronLinkLogo }  alt='TronLink logo' />
    </div>
);

const openTronLink = () => {
    window.open(WEBSTORE_URL, '_blank');
};

const TronLinkGuide = props => {
    const {
        installed = false
    } = props;

    if(!installed) {
        return (
            <div className='row' onClick={ openTronLink }>
                <div className='col-sm-8'>
                     <h1 className="bs-danger">Install TronLink</h1> 
                    <p>You must install TronLink to our website. TronLink is a TRON wallet that you can install at any device at <a href={ WEBSTORE_URL } target='_blank' rel='noopener noreferrer'>TronLinkPro Official Website</a>.Once installed, click back and refresh this page.
                    </p>
                </div>
                { logo }
            </div>
        );
    }

    return (
    <> <a href='/'>

        <div className='tronLink row' style={{'padding': '3em','color': 'black','textDecoration': 'none'}}>

            <div className='info col-sm-8'>
                <h1 className="bs-danger">Login Required!</h1>
                <p>TronLink is installed but you need to log in first. Open TronLink APP and configure your first wallet or unlock an already created wallet.</p>
            </div>
            { logo }
        </div>
        </a>

    </>
    );
};

export default TronLinkGuide;
